import { motion } from "framer-motion";
import { Info } from "lucide-react";

function InfoPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 pt-8 pb-24 bg-gray-50 dark:bg-gray-900">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="w-full max-w-md bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6"
      >
        <h2 className="text-xl font-bold mb-4 text-gray-800 dark:text-white flex items-center">
          <Info className="mr-2 text-green-600" size={20} />
          Über die App
        </h2>
        
        <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
          Diese App hilft dir, basierend auf deinem Konsumverhalten, Körpergewicht und der vergangenen Zeit seit dem 
          Konsum eine grobe Einschätzung zur THC-Konzentration im Blut zu erhalten.
        </p>

        <h3 className="text-lg font-semibold mt-6 mb-2 text-gray-800 dark:text-white">Berechnungsformel:</h3>
        <div className="bg-gray-100 dark:bg-gray-700 rounded-lg p-4 text-sm overflow-auto">
          <p className="text-gray-700 dark:text-gray-300 font-mono">
            THC-Blutkonzentration (ng/ml) =<br /><br />
          </p>
          <div className="border-b border-gray-300 dark:border-gray-600 py-2 mb-2">
            <p className="text-center text-gray-700 dark:text-gray-300 font-mono">
              Menge (g) × THC-Gehalt (%) × Bioverfügbarkeit × 1000
              <br />
              ────────────────────────────────────────────
              <br />
              Körpergewicht (kg) × Verteilungsvolumen
            </p>
          </div>
          <p className="text-gray-700 dark:text-gray-300 font-mono text-center">
            − Abbaufaktor × Zeit (h)
          </p>
          
          <div className="mt-4 text-gray-700 dark:text-gray-300">
            <p className="font-medium">Mit Werten:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Bioverfügbarkeit: Joint 30%, Bong 35%, Vaporizer 50%, Edibles 10%</li>
              <li>Verteilungsvolumen V = 0.6 l/kg</li>
              <li>Abbaukonstante K = 2 ng/ml pro Stunde</li>
            </ul>
          </div>
        </div>
        
        <div className="mt-6 p-4 bg-amber-50 dark:bg-amber-900/30 rounded-lg border-l-4 border-amber-500">
          <p className="text-amber-700 dark:text-amber-400 text-sm">
            <strong>Hinweis:</strong> Die Formel basiert auf konservativen Annahmen und ist nicht rechtsverbindlich. 
            Individuelle Faktoren können zu erheblichen Abweichungen führen.
          </p>
        </div>
      </motion.div>
    </div>
  );
}

export default InfoPage;